import {SEGMENT} from "@reva/shared/reva-spec";

/**
 * Gebäudeart, die REVA beim Beauftragen an reva-rest schickt (`PropertyTypeEnumDto`-Namen der Orders-API).
 * reva-rest bildet sie auf die PropertyTypeId der Orders-API ab.
 */
export type ValueOrderPropertyType =
    | "DetachedHouse"
    | "TownHouseMiddle"
    | "RH_DH"
    | "TwoFamilyHouse"
    | "EFH_ZFH"
    | "ResidentialCommercialBuilding"
    | "ApartmentBuilding"
    | "Condominium"
    | "BuildingGround"
    | "NotDefined";

/**
 * Leitet die Gebäudeart eines Auftrags aus Segment und `building_type` der Bewertung ab.
 * Ohne Segment (bzw. bei unbekanntem Segment) `NotDefined`.
 * @param segment AVM-Segment der Bewertung
 * @param buildingType AVM-Parameter `building_type`
 */
export function segmentBuildingTypeToPropertyType(
    segment: string | null | undefined,
    buildingType: number | null | undefined,
): ValueOrderPropertyType {
    if (!segment) return "NotDefined";
    switch (segment) {
        case SEGMENT.EZFH_K:
            if (buildingType === 7) return "DetachedHouse";
            if (buildingType === 8) return "TownHouseMiddle";
            if (buildingType === 9) return "RH_DH";
            if (buildingType === 10) return "TwoFamilyHouse";
            return "EFH_ZFH";
        case SEGMENT.MFHWGH_K:
            if (buildingType === 19) return "ResidentialCommercialBuilding";
            return "ApartmentBuilding";
        case SEGMENT.WHG_K:
        case SEGMENT.WHG_M:
            return "Condominium";
        case SEGMENT.GRST_K:
            return "BuildingGround";
        default:
            return "NotDefined";
    }
}

/**
 * i18n-Schlüssel des lesbaren Namens einer Gebäudeart (z. B. „Einfamilienhaus" für `EFH_ZFH`).
 * @param propertyType Gebäudeart-Name wie von {@link segmentBuildingTypeToPropertyType}
 */
export function propertyTypeLabelKey(propertyType: string): string {
    return `commissionOrderDialog.propertyType.${propertyType}`;
}
